// @flow

export const GENDER_FEMALE = "female";
export const GENDER_MALE = "male";
export const GENDER_NON_BINARY = "non_binary";

const genderOptions = [
  {
    label: "Frau",
    value: GENDER_FEMALE
  },
  {
    label: "Herr",
    value: GENDER_MALE
  },
  {
    label: "Divers",
    value: GENDER_NON_BINARY
  }
];

export const genderLabels = genderOptions.reduce(
  (acc, { value, label }) => ({ ...acc, [value]: label }),
  {}
);

export default genderOptions;
